export default "__VITE_ASSET__DeZ9O9sV__"